import React from 'react';
import { Box, Grid } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { CircularProgress, InfoField, Typography } from '@occc-app/design-system';
import { PhoneNumberMetadataFragment } from '@occc/graphql';

type MemberDetailsFieldsProps = {
  phoneNumberMetadata?: PhoneNumberMetadataFragment;
  isPhoneNumberLoading: boolean;
  isPhoneNumberMetadataError?: ApolloError;
};

type MemberDetailsField = {
  name: string;
  attribute: keyof PhoneNumberMetadataFragment;
  defaultValue: string;
  format?: (input: string) => string;
};

const fields: MemberDetailsField[] = [
  {
    name: 'Country Code',
    attribute: 'countryCode',
    defaultValue: 'No Country Code',
  },
  {
    name: 'Carrier Type',
    attribute: 'carrier',
    defaultValue: 'No Carrier Type',
  },
  {
    name: 'Phone Type',
    attribute: 'phoneType',
    defaultValue: 'No Phone Type',
  },
];

export const MemberPhoneNumberMetadata = ({
  phoneNumberMetadata,
  isPhoneNumberLoading,
  isPhoneNumberMetadataError,
}: MemberDetailsFieldsProps) => {
  if (isPhoneNumberLoading && !phoneNumberMetadata) {
    return <CircularProgress />;
  }

  if (isPhoneNumberMetadataError) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {fields.map((field) => {
          const value = phoneNumberMetadata?.[field.attribute]?.toString();
          return (
            <Grid item xs={12} md={3} key={field.attribute}>
              <InfoField
                label={field.name}
                value={value && field.format ? field.format(value) : value || field.defaultValue}
                sx={{ overflowWrap: 'anywhere' }}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
